<template>
  <div>
    <nav id="navbar-container" class="relative flex! h-14 w-full flex-row items-center justify-between bg-gray-900 px-6! py-3">
      <RouterLink :to="'/'">
        <InvoxiaLogo />
      </RouterLink>

      <div class="-m-3! cursor-pointer p-3!" @click="expanded = !expanded">
        <BurgerIcon :stroke="'white'" />
      </div>

      <!-- dropdown menu -->
      <Transition
        enter-active-class="transition-all duration-100 ease-out"
        enter-from-class="opacity-0 scale-95 -translate-y-2"
        enter-to-class="opacity-100 scale-100 translate-y-0"
        leave-active-class="transition-all duration-100 ease-in"
        leave-from-class="opacity-100 scale-100 translate-y-0"
        leave-to-class="opacity-0 scale-95 -translate-y-2"
      >
        <div v-if="expanded" class="absolute top-full right-0 z-50 min-w-48 origin-top-right rounded-lg border border-gray-200 bg-white py-2 shadow-xl md:mr-5!">
          <ul class="m-0! list-none p-4!">
            <li>
              <RouterLink
                v-if="isEmailVerified"
                to="/subscription"
                class="block rounded-2xl border-b border-gray-100 px-4! py-3! text-gray-700! no-underline transition-colors duration-200 hover:bg-gray-50!"
                @click="expanded = false"
              >
                <span class="font-medium first-letter:capitalize">{{ $t('subscriptions') }}</span>
              </RouterLink>
              <div v-else class="block cursor-not-allowed rounded-2xl border-b border-gray-100 px-4! py-3! text-gray-400! no-underline">
                <span class="font-medium first-letter:capitalize">{{ $t('subscriptions') }}</span>
              </div>
            </li>
            <li>
              <RouterLink
                v-if="isEmailVerified"
                to="/orders"
                class="block rounded-2xl border-b border-gray-100 px-4! py-3! text-gray-700! no-underline transition-colors duration-200 hover:bg-gray-50!"
                @click="expanded = false"
              >
                <span class="font-medium first-letter:capitalize">{{ $t('orders') }}</span>
              </RouterLink>
              <div v-else class="block cursor-not-allowed rounded-2xl border-b border-gray-100 px-4! py-3! text-gray-400! no-underline">
                <span class="font-medium first-letter:capitalize">{{ $t('orders') }}</span>
              </div>
            </li>
            <li>
              <RouterLink
                v-if="isEmailVerified"
                to="/subscription-invoices"
                class="block rounded-2xl border-b border-gray-100 px-4! py-3! text-gray-700! no-underline transition-colors duration-200 hover:bg-gray-50!"
                @click="expanded = false"
              >
                <span class="font-medium first-letter:capitalize">{{ $t('subscription_invoices') }}</span>
              </RouterLink>
              <div v-else class="block cursor-not-allowed rounded-2xl border-b border-gray-100 px-4! py-3! text-gray-400! no-underline">
                <span class="font-medium first-letter:capitalize">{{ $t('subscription_invoices') }}</span>
              </div>
            </li>
            <li>
              <a
                class="block rounded-2xl border-b border-gray-100 px-4! py-3! text-gray-700! no-underline transition-colors duration-200 hover:bg-gray-50!"
                href="https://www.invoxia.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span class="font-medium">{{ $t('shop') }}</span>
              </a>
            </li>
            <li>
              <button
                type="button"
                class="w-full cursor-pointer rounded-2xl! border-b border-gray-100 bg-transparent px-4! py-3! text-left font-medium text-red-600 transition-colors duration-200 hover:bg-red-50!"
                @click="processLogout()"
              >
                {{ $t('logout') }}
              </button>
            </li>
            <li class="pt-3!">
              <span class="px-4! text-xs! font-light!">{{ getUserName }}</span>
            </li>
            <li>
              <span class="px-4! text-xs! font-light!">{{ $t('version') }}: {{ version }}</span>
            </li>
          </ul>
        </div>
      </Transition>
    </nav>
  </div>
</template>

<script setup lang="ts">
import '@/assets/scss/style.scss'
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

import BurgerIcon from '@/svg/burgerIcon.vue'
import InvoxiaLogo from '@/svg/invoxiaLogo.vue'

const version = ref('')
const expanded = ref(false)

const store = useStore()
const router = useRouter()

const getUserName = computed(() => store.getters['users/getUserName'])
const isEmailVerified = computed(() => store.getters['users/getEmailConfirmed'])

const logout = () => store.dispatch('users/logout')
const removeDevices = () => store.dispatch('devices/removeDevices')
const fetchUserData = () => store.dispatch('users/fetchUserData')

onMounted(async () => {
  if (window._env_?.ITP_VERSION) {
    version.value = window._env_.ITP_VERSION
  }

  if (!getUserName.value) {
    await fetchUserData()
  }

  // Give zendesk script loading responsibility to the layout not the nav bar
  // Close dropdown when clicking outside
  document.addEventListener('click', checkClickOutside)

  // Load Zendesk snippet
  // const script = document.createElement('script')
  // script.id = 'ze-snippet'
  // script.src = 'https://static.zdassets.com/ekr/snippet.js?key=bd28e588-5090-4bf6-9615-833fffb8d9d4'
  // document.body.appendChild(script)
})

onUnmounted(() => {
  document.removeEventListener('click', () => {})
})

const checkClickOutside = (event) => {
  const navbar = document.getElementById('navbar-container')
  const target = event.target as Element

  if (navbar && !navbar.contains(target)) {
    expanded.value = false
  }
}

const processLogout = () => {
  logout()
  removeDevices()
  expanded.value = false
  router.push({ name: 'login' })
}
</script>
